var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.data.items.length > 0)?_c('div',{staticClass:"C-block-type-102"},[_vm._l((_vm.blocks),function(blocks,index){return [_c(blocks.name,{key:index,tag:"component",attrs:{"data":blocks.data,"settings":blocks.settings}})]})],2):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }